import { AuthContext } from "@/auth/authcontext.tsx";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router";

export default function LogoutPage() {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();
  useEffect(() => {
    logout();
    navigate("/");
  }, []);

  return null;
}
